import ProFeatureDialog from '@/components/ProFeatureDialog';
import { useTranslation } from 'react-i18next';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onUpgrade: () => void;
}

/**
 * The success-moment nudge: the user just downloaded a clip and nothing was
 * blocked, so the copy celebrates first and offers second. It wraps
 * `ProFeatureDialog` — as `QuotaUpsellDialog` does — so the price anchor and
 * visual language cannot drift from the blocking gates.
 */
const DownloadUpsellDialog = ({ open, onOpenChange, onUpgrade }: Props) => {
  const { t } = useTranslation();

  return (
    <ProFeatureDialog
      open={open}
      onOpenChange={onOpenChange}
      onUpgrade={onUpgrade}
      title={t('downloadUpsell.title')}
      body={t('downloadUpsell.body')}
      dismissLabel={t('downloadUpsell.dismiss')}
      upgradeLabel={t('downloadUpsell.upgrade')}
      testIdPrefix="download-upsell"
    />
  );
};

export default DownloadUpsellDialog;
